// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#settings-modal-content .message-head-settings{margin-bottom:40px}#settings-modal-content .button-continue{min-width:250px;margin-bottom:20px}\n", ""]);
// Exports
module.exports = exports;
